import { SetStateAction, useContext } from 'react'
import { Tags } from '@telus-uds/components-web'
import { articleConsumer } from '@/blogBuilder/provider/ArticleProvider'
import frenchMapping from '@/blogBuilder/utils/frenchMapping'

type Props = {
  tags: string[]
  lang: string
}

const FilterTags = ({ tags, lang }: Props) => {
  const { selectedTags, setSelectedTags, setCurrentPage } = useContext(articleConsumer)
  if (!tags?.length) return null

  const items = tags.map((tag) => {
    if (lang === 'fr') {
      return { label: frenchMapping[tag], id: tag }
    }
    return { label: tag, id: tag }
  })

  const handleChange = (state: SetStateAction<string[]>) => {
    setCurrentPage(0)
    setSelectedTags(state)
  }

  return <Tags items={items} maxValues={10} onChange={handleChange} values={selectedTags} />
}

export default FilterTags
